module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/asyncloader.js!./loaders/async/loaders/asyncloader.js!./loaders/async/a.js
 ** module id = 7
 ** module chunks = 0
 **/